module.exports = __webpack_public_path__ + "ProximaNova-Regular.woff?2d2ae2556b24a45ff8d5ed86b07b5783";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ProximaNova-Regular.woff
// module id = 41
// module chunks = 0